import React from 'react'
import { mount } from '../utils/mount'
import { ProductHydroLight25Page } from '../pages/product-hydro-light-25-page'
import { PageRoot } from '../components/page-root'

mount('#skn-remed-product-page', <PageRoot><ProductHydroLight25Page /></PageRoot>)